import {
    SET_TAX_RATE,
    SET_INSTALL_YEAR,
    SET_TAX_ENTITY,
    SET_RESI_TOGGLE,
    SET_TAX_IPUTS,
} from './constants';

const defaultState = {
    installYear: 2020,
    taxRate: 21,
    taxEntity: true,
    resiToggle: true,
};

const tax = (state = defaultState, action) => {
    switch (action.type) {
        case SET_TAX_IPUTS:
            return {
                installYear: action.taxObligation.installationYear,
                taxRate: action.taxObligation.rate,
                taxEntity: action.taxObligation.taxPayingEntity,
                resiToggle: action.taxObligation.residential,
            };
        case SET_INSTALL_YEAR:
            return { ...state, installYear: action.installYear };

        case SET_TAX_RATE:
            return { ...state, taxRate: action.taxRate };

        case SET_TAX_ENTITY:
            return { ...state, taxEntity: action.taxEntity };

        case SET_RESI_TOGGLE:
            return { ...state, resiToggle: action.resiToggle };

        default:
            return state;
    }
};

export default tax;



// WEBPACK FOOTER //
// ./src/containers/common/tax/reducer.js